import React, { useEffect, useState } from 'react';

export default function InterviewSection({ choose, nameSend, t }) {
    const [jitsiLoaded, setJitsiLoaded] = useState(false);

    useEffect(() => {
        const domain = 'jitsi.smallsolutions.es';  // 🔹 Tu servidor Jitsi personalizado
        const roomName = `Entrevista (${choose?._id})`; // 🔹 Nombre de la sala basado en el ID de la entrevista

        // 🔹 Solicitar permisos de cámara y micrófono antes de iniciar Jitsi (para evitar bloqueos en móvil)
        navigator?.mediaDevices?.getUserMedia({ video: true, audio: true })
            .then(() => console.log("Permisos de cámara y micrófono concedidos"))
            .catch(err => console.error("Error obteniendo permisos de WebRTC:", err));

        // 🔹 Función para cargar el script de Jitsi solo si no está ya presente
        const loadJitsiScript = () => {
            if (document.getElementById('jitsi-script')) {
                setJitsiLoaded(true);
                return;
            }

            const script = document.createElement('script');
            script.src = 'https://jitsi.smallsolutions.es/external_api.js';  // 🔹 O usa el de tu servidor si tienes uno propio
            script.async = true;
            script.id = 'jitsi-script';

            script.onload = () => setJitsiLoaded(true);
            document.body.appendChild(script);
        };

        loadJitsiScript();

        if (jitsiLoaded && window.JitsiMeetExternalAPI) {
            const options = {
                roomName,
                parentNode: document.getElementById('jitsi-container'),
                configOverwrite: {
                    startWithAudioMuted: false,
                    startWithVideoMuted: false,
                },
                interfaceConfigOverwrite: {
                    TOOLBAR_BUTTONS: [
                        'microphone',
                        'camera',
                        'fullscreen',
                        'hangup',
                        'settings',
                    ],
                },
                userInfo: {
                    displayName: nameSend,
                },
            };

            const api = new window.JitsiMeetExternalAPI(domain, options);

            return () => api.dispose();
        } else {
            console.error('JitsiMeetExternalAPI no está disponible.');
        }
    }, [choose, jitsiLoaded]); // 🔹 Se ejecuta solo cuando Jitsi está cargado y `choose` cambia

    return <div id="jitsi-container" style={{ height: '100%', width: '100%' }}></div>;
}
